import React, { useEffect } from 'react';
import { useQuery, useMutation } from 'react-query';
import { useForm } from 'react-hook-form';

import { InterestsService, smartRecommendationsInitService } from 'services/auth';
import { getAccessToken } from 'utils/authentication';
import { getErrorText } from 'utils/geterrortext';
import ActionButton from '@core/components/actionbutton/ActionButton';
import Checkbox from '@core/components/checkbox/Checkbox';

import classes from './InterestsForm.module.scss';



const InterestsForm = ({ closeHandler, refetchHandler, toast, type = 'account' }) => {
    const [selectedInterests, setSelectedInterests] = React.useState([]);
    const { data, isLoading } = useQuery(
        ['interests-info', getAccessToken()],
        () => InterestsService.GET()
    );
    const { mutate } = useMutation(InterestsService.PUT, {
        onSuccess: async () => {
            await smartRecommendationsInitService();
            refetchHandler();
            if (type === 'account')
                closeHandler();
        },
        onError: (err) => {
            toast(
                getErrorText(err),
                'alert'
            );
        }
    });

    const {
        handleSubmit,
    } = useForm({
        mode: 'onChange',
        shouldFocusError: false,
        defaultValues: {}
    });

    useEffect(() => {
        if (data?.data?.interests) {
            setSelectedInterests(data.data.interests);
        }
    }, [data]);

    // Checkbox change handler
    const handleCheckboxChange = (interest) => {
        setSelectedInterests((prev) =>
            prev.includes(interest)
                ? prev.filter((i) => i !== interest)
                : [...prev, interest]
        );
    };

    const submitForm = async () => {
        try {
            if (selectedInterests.length === 0) {
                toast('Please select at least one interest', 'alert');
                return;
            }
            await mutate({ interests: selectedInterests });
        } catch (e) {
            console.log('error', e)
        }
    };

    return (
        <div className={classes.wrapper}>
            <h3>Choose what matters for your role</h3>
            <p>Select the skills you want to strengthen at work, and we’ll recommend where to begin.</p>
            {data && !isLoading && (
                <form onSubmit={handleSubmit(submitForm)} className="d-flex flex-column gap-3">
                    <div className={classes['items-wrapper']}>
                        {data?.data?.metadata.interests.map((interest) => (
                            <Checkbox
                                key={interest}
                                input={{
                                    name: `choices`,
                                    label: interest,
                                    id: `${interest}`,
                                    checked: selectedInterests.includes(interest),
                                }}
                                onChange={() => handleCheckboxChange(interest)}
                                type='survey'
                            />
                        ))}
                    </div>
                    <div className='d-flex justify-contetnt-center gap-5  px-md-5 px-0 mt-4'>
                        <ActionButton kind='blank' onClick={closeHandler}>
                            {type === 'account' ? 'Cancel' : 'Back'}
                        </ActionButton>
                        <ActionButton type="submit">
                            {type === 'account' ? 'Save' : 'Next'}
                        </ActionButton>
                    </div>
                </form>
            )}
        </div>
    );
};

export default InterestsForm;